module.exports = "https://lts-static.prod-my.games/promo/lp1/img/weapon-1.4998610a.png";